export const T = (key: any) => {
  // const { values }: any = useSelector((state: RootState) => state.phrase.activeTranslation);
  let values: any = {};
  let translation = key;
  if (values) {
    translation = values[`${key}`];
  }
  return translation ? translation : key;
};
